import { render, staticRenderFns } from "./BlogDetails.vue?vue&type=template&id=2ccf8d88&"
import script from "./BlogDetails.vue?vue&type=script&lang=js&"
export * from "./BlogDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports